import { Image, Spinner } from "@wayflyer/flyui";
import { IconLink24Line as LinkIcon } from "@wayflyer/flyui-icons/24/line";
import { styled } from "styled-components";

import { ConnectorIconBorder, ConnectorIconContainer } from "../../styled/index";

import { type ConnectorLogoSize } from "./connector-logo";
import { sizeMap } from "./connector-logo.const";

// The default images contain some whitespace padding within the image itself. We pad loadable images a bit
// to stop them appearing too large
export const StyledLoadableConnectorLogo = styled(Image)<{
  $size: ConnectorLogoSize;
}>`
  width: ${({ $size = "standard" }) => sizeMap[$size].full - 20}px;
  height: ${({ $size = "standard" }) => sizeMap[$size].full - 20}px;
  border-radius: var(--sizes-radius-sm);
  padding: 10px;

  @media (max-width: 640px) {
    width: ${({ $size = "standard" }) => sizeMap[$size].reduced - 20}px;
    height: ${({ $size = "standard" }) => sizeMap[$size].reduced - 20}px;
    padding: 10px;
  }
  /**
    Improves layout for iPhones
   */
  @media (width: 414px) {
    width: ${({ $size = "standard" }) => sizeMap[$size].full - 20}px;
    height: ${({ $size = "standard" }) => sizeMap[$size].full - 20}px;
    padding: 10px;
  }
`;

export type LoadableConnectorLogoProps = {
  ariaLabel?: any;
  connectorName: string;
  source: string;
  fallbackIcon?: React.ReactNode;
  alt?: string;
  size?: ConnectorLogoSize;
  disabled?: boolean;
  isLoading?: boolean;
  canLoad?: boolean;
};

const SpinnerContainer = styled.div`
  padding: 21px;
`;

export const LoadableConnectorLogo = (props: LoadableConnectorLogoProps) => {
  const {
    connectorName,
    alt = "",
    ariaLabel = "",
    size = "small",
    source,
    fallbackIcon,
    isLoading,
    canLoad = true,
    ...other
  } = props;
  if (isLoading) {
    return (
      <SpinnerContainer>
        <Spinner size={32} />
      </SpinnerContainer>
    );
  } else if (!canLoad) {
    return (
      <ConnectorIconContainer>
        <ConnectorIconBorder>{fallbackIcon ? fallbackIcon : <LinkIcon />}</ConnectorIconBorder>
      </ConnectorIconContainer>
    );
  } else {
    return (
      <StyledLoadableConnectorLogo
        {...other}
        $size={size}
        src={source}
        alt={alt}
        title={connectorName}
        aria-label={ariaLabel}
      />
    );
  }
};
